import { useEffect } from "react";
import { logoutUser } from "../../utils/logoutUser";
import { Type } from "@shared/ui/Type";

type Props = {
  onError?: (error: Error) => void;
  onSuccess?: () => void;
};

export function LogoutContainer({ onError, onSuccess }: Props) {
  const handleLogout = async () => {
    try {
      await logoutUser();

      onSuccess?.();
    } catch (error) {
      onError?.(error as Error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      handleLogout();
    }, 500);
  }, []);

  return (
    <div className="flex flex-1 flex-col items-center justify-center">
      <Type as="h1" variant="h3">
        Logging out...
      </Type>
    </div>
  );
}

export default LogoutContainer;
